import type { Player } from "../types/domain";

type PlayerLike = Pick<Player, "firstname" | "lastname" | "nickname" | "elo">;

export const playerToString = (player: PlayerLike, includeElo: boolean = false, aliasOnly: boolean = false): string => {
  const elo = includeElo ? " (" + player.elo + ")" : "";
  if (aliasOnly && player.nickname) {
    return player.nickname + elo;
  }
  return player.firstname + (player.nickname ? " \"" + player.nickname + "\" " : " ") + player.lastname + elo;
};

export const playerToStringLastnameFirst = (player: PlayerLike, includeElo: boolean = false): string => {
  const elo = includeElo ? " (" + player.elo + ")" : "";
  return player.lastname + (player.nickname ? " \"" + player.nickname + "\" " : " ") + player.firstname + elo;
};

/** Strip diacritics + lowercase for locale-friendly substring matching. */
export const normalizeForSearch = (s: string): string =>
  s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

export const signedNumber = (number: number | null, signedZero: boolean = false): string | null => {
  if (number === null) {
    return null;
  } else if (number > 0) {
    return "+" + number;
  } else if (number === 0 && signedZero) {
    return "+" + number;
  } else {
    return number.toString();
  }
};

export const formatDate = (date: string): string =>
  new Intl.DateTimeFormat("cs-CZ", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  }).format(new Date(date.slice(0, 10)));

export const formatTime = (date: string): string =>
  new Intl.DateTimeFormat("cs-CZ", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  }).format(new Date(date));

export const formatDurationSeconds = (totalSeconds: number): string => {
  const safe = Math.max(0, Math.round(totalSeconds));
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return minutes > 0 ? `${minutes} min ${seconds} s` : `${seconds} s`;
};
